module.exports = __webpack_public_path__ + "img/Scan_01.1eebfdcb.png";